
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';
import {FormControl, FormGroup, FormBuilder} from "@angular/forms";
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import { HttpClient } from '@angular/common/http';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog'
import { Inject} from '@angular/core';
import Swal from 'sweetalert2';
import { Norm35DocumentComponent } from '../../norm35-document/norm35-document.component';
import { request } from 'http';
import * as backInter from 'app/auth/auth-data.model';
import { Colaboradores35Service } from 'app/main/wizard-n35/services/colaboradores35.service';
import { FormArray } from '@angular/forms';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import *  as $ from 'jquery';
import { swalProviderToken } from '@sweetalert2/ngx-sweetalert2/lib/di';
import { fuseAnimations } from '@fuse/animations';
///IDIOMAS
import { DATOS_API } from 'app/auth/auth.datos';
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
const longText = `Mega Man X, known in Japan as Rockman X,[a] is an action-platform video game developed and published by Capcom for the Super Nintendo Entertainment System (SNES).
  1
  2
  3`;
  import { Subject } from 'rxjs';
  export interface DialogData {
    opcion: any;
    title: any;
    seccionId:any;
    tareaId:any;
    infoapoyo:any;
    tipo:any;
    status:any;
  }
@Component({
  selector: 'app-tables-steps',
  templateUrl: './tables-steps.component.html',
  styleUrls: ['./tables-steps.component.scss']
})
export class TablesStepsComponent implements OnInit {
  // ARREGLOS PARA GUARDAR TRADUCCIONES DE LA CARPETA IDIOMAS
  mensajesTraducirKeys: string[] = [
    'WIZARD.MENSAJES.ADVICE1',
    'WIZARD.MENSAJES.ADVICE2',
    'WIZARD.MENSAJES.ADVICE3',
    'WIZARD.MENSAJES.ADVICE4',
    'WIZARD.MENSAJES.ADVICE5',
    'WIZARD.MENSAJES.ADVICE6',
    'WIZARD.MENSAJES.ADVICE7',
    'WIZARD.MENSAJES.ADVICE8',
    'WIZARD.MENSAJES.ADVICE9',
    'WIZARD.MENSAJES.ADVICE10',
    'WIZARD.MENSAJES.ADVICE11',
    'WIZARD.MENSAJES.ADVICE12',
    'WIZARD.MENSAJES.ADVICE13',
  ];

  mensajesTraducirTS = {
    guarda_1: '',
    guarda_2: '',
    guarda_3: '',
    guarda_4: '',
    guarda_5: '',
    guarda_6: '',
    guarda_7: '',
    guarda_8: '',
    guarda_9: '',
    guarda_10: '',
    guarda_11: '',
    guarda_12: '',
    guarda_13: '',
  };
    // FIN ARREGLOS PARA GUARDAR TRADUCCIONES DE LA CARPETA IDIOMAS
  productoCertificar: backInter.prodNorma35;
  @Input() inputArray: Array<any>[];
  myForm: FormGroup;
  // INICIO DE AUTISZE
  public longText = longText;
  public minRows = 3;
  public maxRows = 4;
  public onlyGrow = true;
  public useImportant = true;

  @Output() idPreguntaBorrar: EventEmitter<number> = new EventEmitter();
  @Output() mensajeSnack: EventEmitter<any> = new EventEmitter();
  @Output() mensajeSwal: EventEmitter<any> = new EventEmitter();
  reactiveText = new FormControl(longText);
  reactiveForm = new FormGroup({
    reactiveText: new FormControl(longText)
  });
  // FIN AUTOSIZE
  typeContent:number;

  // Variable cargando
  cargando= true;
  idiomaActual:string;
  //Variables que se Ocupan en html//
  disabled = false;
  pathTmp= "http://104.154.162.169/surveyadministrator/backend/";

  tmpFilePrimary: any;
  //Fin Variables que se Ocupan en html//
  //Variables que se Ocupan en .ts//
  dataFilePrimary: any;
  lado = 4;
  dataId : any ;
  tittleTmpTable:any;
  idSeccionTmp: any;
  nombreSeccionTmp: any;
  requerimientoTmp: any;
  instruccion1Tmp: any;
  InfoTabla: any;
  TaskLisktpm: any;
  rutaListaTmp: any;
  dataTaskList: any;
  fieldArray: Array<any> = [];
  newAttribute: any = {};
  DataTaskFile:any;
  selectedFile:File = null;
  dataFile: any ;
  uploadFiles: Array<File>;
  archivosDatos: any;
  //tipoPregunta: number;
  fieldArrayTask2: Array<any> = [];
  newAttributeTas2k: any = {};
  typeEvent: string;
  nombreSeccion: string;
  data : any;
  dataStep: any;
  ObjTmp: any;
  fechaDocumentador_P: any;
  idSeccion : any;
  //Variables Funcion sendInfoTable
  definicionTmp: any;
  criterioTmp: any;
  apoyoTmp: any;
  uploadedFiles4: any ;
  // Tareas primarias
  dataTaskprimary:any;
  IdPrimarytaskTmpFirtsSave: any;
  PrimaryTaskTmpFirts: any
  primaryTask: any;
  //Variable que bloquea el select|| Manda Alerta celda vacia
  validadorMatSelect: boolean[] = [];
  validadorMatArchivo: boolean[] = [];
  Tmpstatus:any;
  favoriteSeason:any;
  uploadedFilesPrimary: any ;
  fieldArrayTask3: Array<any> = [];
  newAttributeTask3: any = {};
  files: any = [];
  tmpIndex_aux:any;
  index_tmpFile:any;
  arrayFIlesTmp: any = [];
  File_tmpaux;
  fechaCertificar: any;
  // Nuevas variables
  master35:any;
  statusmater=false;
  idiomaBanner:any;
  //Fin Variables que se Ocupan en .ts//
  checkedDone = true;
  checkedNoDone = false;
  PasswordInabe:boolean = false;
  InabeObv:boolean = true;
  htp:string;
  urlServidor:string;
  private _unsubscribeAll: Subject<any>;
  constructor(private activated: ActivatedRoute,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private colaboradoresService: Colaboradores35Service,
    private idiomasService: IdiomasServiceN35, private formBuilder: FormBuilder,
    private httpClient: HttpClient, private http: HttpClient, private fb: FormBuilder,
    private translateSrv: TranslateService,
    public dialog: MatDialog
    ) {
    let url = DATOS_API.url.split(":");
    let htp = DATOS_API.url.split("/");
    this.htp = htp[0];
    this.urlServidor = url[1];
    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang,this.dataId); });
    this.getMaster();
    /*console.log("Nuevas direcciones");
    console.log(htp);
    console.log(this.urlServidor);*/
  }

  ngOnInit() {
    this.traduceTextosTS();
    this.obtieneCertificarActual();
    this.activated.data.subscribe  (params=>{this.dataId = params});
    this.tittleTmpTable=this.getInfoTable(this.dataId);
    this.InfoTabla = this.sendInfoTable(this.tittleTmpTable);
    this.cambiaIdiomaBanner(this.translateSrv.currentLang,this.dataId);

  }

  // FUNCIÓN QUE SE MANDA POR PARAMETRO EL IDIOMA ACTUAL Y EL ID DEL PASO PARA DETECTAR EL BANNER CORRESPONDIENTE
  cambiaIdiomaBanner(idioma:string, step:any){
    this.traduceTextosTS();
    this.idiomaBanner = this.translateSrv.currentLang;
    switch(idioma){
      case 'es': this.idiomaBanner = idioma; break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner(step.id);
  }
  urlBanner:any;
  getBanner(numStep){
    switch(numStep){
      case '52':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-18.png';
      break;
      case '53':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-06.png';
      break;
      case '54':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-05.png';
      break;
      case '55':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-08.png';
      break;
      case '56':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-07.png';
      break;
      case '51a':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-09.png';
      break;
      case '51b':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-10.png';
      break;
      case '51c':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-14.png';
      break;
      case '57a':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-15.png';
      break;
      case '57b':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-16.png';
      break;
      case '57c':
        this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-17.png';
      break;

    }

  }

  getMaster(){
    this.master35=this.idiomasService.getIDempresa();

    if(this.idiomasService.getIDempresa()== '5e78de22e2f2d4411a5f4e5e' || this.idiomasService.getIDempresa() =='5e87bf11d6642714933d567b'){
      this.statusmater=true;
    }
  }

  updateReactiveText() {
    const current = this.reactiveText.value;
    this.reactiveText.setValue(current + "");
  }

  updateReactiveFormText() {
    const current = this.reactiveForm.value.reactiveText;
    this.reactiveForm.setValue({
        reactiveText: current + " "
    });
  }


  public open() {
    this.fechaDocumentador_P = this.fechaCertificar;
    let Objtamanio: any;
    this.idiomasService.getStepsData(this.fechaDocumentador_P).subscribe(( data:any )=>{
      if(data.message=="Success"){
        Objtamanio = data.secciones.length;
        this.dataStep=data.secciones[0];
        this.idSeccion = this.dataStep._id;
      }
    });
  }


  // Detail Control
  private onBlurPractica(event,idTable,tipo,nameSeccion){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.data = {
      idSeccion : idTable,
      fechaDocumentador: this.fechaCertificar,
      numeroTabla: "1",
      nombreSeccion: nameSeccion,
      requerimiento: ""+this.typeEvent,
    };
    this.idiomasService.guardaDatosStep5(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }
  private onBlurSecond(event,idTable,tipo,nameSeccion){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.typeEvent = event.target.value;
      this.data = {
        idSeccion : idTable,
        fechaDocumentador: this.fechaCertificar,
        numeroTabla: "1",
        nombreSeccion: nameSeccion,
        instruccion1: this.typeEvent,
      };
    this.idiomasService.guardaDatosStep5(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }
  private onBlurDefinicion(event,idTable,tipo,nameSeccion){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.typeEvent = event.target.value;
      this.data = {
        idSeccion : idTable,
        fechaDocumentador: this.fechaCertificar,
        numeroTabla: "1",
        nombreSeccion: nameSeccion,
        definicion: this.typeEvent,
      };
    this.idiomasService.guardaDatosStep5(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }

  private onBlurCriterios(event,idTable,tipo,nameSeccion){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.typeEvent = event.target.value;
      this.data = {
        idSeccion : idTable,
        fechaDocumentador: this.fechaCertificar,
        numeroTabla: "1",
        nombreSeccion: nameSeccion,
        criterio: this.typeEvent,
      };
    this.idiomasService.guardaDatosStep5(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }

  private onBlurApoyo(event,idTable,tipo,nameSeccion){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.typeEvent = event.target.value;
      this.data = {
        idSeccion : idTable,
        fechaDocumentador: this.fechaCertificar,
        numeroTabla: "1",
        nombreSeccion: nameSeccion,
        apoyo: this.typeEvent,
      };
    this.idiomasService.guardaDatosStep5(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }

 private firtsSave(event,tipo,nameSeccion){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.typeEvent = event.target.value;
      this.data = {
        fechaDocumentador: this.fechaCertificar,
        numeroTabla: "1",
        nombreSeccion: nameSeccion,
        requerimiento: this.typeEvent,
      };
    this.idiomasService.guardaDatosStep5(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }

  private SaveData(arregloData){
    // Función para guardar información
    this.idiomasService.guardaDatosStep5(arregloData).subscribe( (data : any) => {
      console.log(data);
    });
  }

  private onPassword(event){
   let Pass:any;
   Pass=event.target.value.trim();
   console.log("Password "+Pass);
   if(Pass == this.productoCertificar.claveInabe){
     this.PasswordInabe=true;
     this.InabeObv=false;
     Swal.fire({
       icon: 'success',
       title: 'Contraseña correcta', // advice 5
       confirmButtonColor: '#e40601'
     });
   }else{
     Swal.fire({
       icon: 'error',
       title: 'Contraseña no valida', // advice 5
       confirmButtonColor: '#e40601'
     });
   }
 }

  private getInfoTable(idData){
    let i = 0 ;
    let posTmp : any;
    let tittleTmp: any;
    for( i=0; i < this.dataStep5.length;i++){
      if(this.dataStep5[i].position == idData.id){
        tittleTmp = this.dataStep5[i].tittle;
      }
    }
    this.cargando=false;
    return tittleTmp;
  }

  private sendInfoTable(tittle){
    let Objtamanio: any;
    let i:0;
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaDocumentador_P=this.productoCertificar.fechaNorma35;
              // FUNCIÓN PARA OBTENER INFORMACIÓN DE LA TABLA
              this.idiomasService.getStepsData(this.fechaDocumentador_P).subscribe(( data:any )=>{
                if(data.message=="Success"){
                  var dataAux:any[]=[];
                    for(i=0; i<data.secciones.length; i++){
                      if(data.secciones[i].nombreSeccion==tittle){
                        this.ObjTmp=data.secciones[i];
                        this.idSeccionTmp = data.secciones[i]._id;
                        this.getAllPrimaryTask(this.idSeccionTmp,tittle); // Files Task
                        this.nombreSeccionTmp = data.secciones[i].nombreSeccion;
                        this.requerimientoTmp = data.secciones[i].detalleControl.requerimiento;
                        this.instruccion1Tmp = data.secciones[i].detalleControl.instruccion1;
                        this.definicionTmp = data.secciones[i].detalleControl.definicion;
                        this.criterioTmp = data.secciones[i].detalleControl.criterio;
                        this.apoyoTmp = data.secciones[i].detalleControl.apoyo;
                        if(!this.apoyoTmp){ this.apoyoTmp=" "}
                        this.rutaListaTmp = " "+data.secciones[i].detalleVerificacion.definicion;
                        this.dataTaskList = {
                          idSeccion : this.idSeccionTmp,
                          fechaDocumentador: this.fechaDocumentador_P,
                        };
                        this.idiomasService.getTaskOnly(this.dataTaskList).subscribe((dataS:any)=>{
                          this.TaskLisktpm = dataS.tareas;
                        });
                      }
                    }
                }
              });
              // FIN
              throw BreakException;
            }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  private GuardarArchivos(idSeccion){
    let archivo;
    archivo = this.DataTaskFile;
    this.data = {
      file: archivo,
      fechaDocumentador: this.fechaCertificar,
      seccionId: idSeccion,
    };
    this.idiomasService.sendFilesValues(this.data).subscribe( (data : any) => {

    });
  }


  private borrarArchivos(seccionID,archivoID,index){
    this.data = {
      fechaDocumentador: this.fechaCertificar,
      seccionId: seccionID,
      archivoId: archivoID
    };
    this.idiomasService.DeleteFileValues(this.data).subscribe( (dataD : any) => {
    });
    this.deleteFieldValue(index);
  }

  addFieldValue() {
    this.fieldArray.push(this.newAttribute)
    this.newAttribute = {};
  }

  deleteFieldValue(index) {
    this.DataTaskFile.splice(index,1);
  }

  fileChange4(element) {
    this.uploadedFiles4 = element.target.files;
    for (let index = 0; index < element.length; index++) {
      const element2 = element[index];
    }
  }

  upload4(idseccion) {
    let formData = new FormData();
    for (var i = 0; i < this.uploadedFiles4.length; i++) {
      formData.append('file',this.uploadedFiles4[i]);
    }
    formData.append("fechaDocumentador",this.fechaCertificar);
    formData.append("seccionId",idseccion);
    this.idiomasService.sendFilesValues(formData).subscribe( (data : any) => {
      if(data.message == "File upload"){
        Swal.fire({
          icon: 'success',
          title: ''+this.mensajesTraducirTS.guarda_2, // advice 2
          html: '<h1></h1>',
          timer: 1500
        });
      }else{
        Swal.fire({
          icon: 'error',
          title: ''+this.mensajesTraducirTS.guarda_3, // advice 3
          html: '<h1></h1>',
          timer: 1500
        });
      }
    });
  }

  addFieldValuePrimaryTask(idseccion) { // Función para agregar nuevas tareas
    Swal.fire({
      width: '550px',
      title: ''+this.mensajesTraducirTS.guarda_4, // advice 4
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.mensajesTraducirTS.guarda_13 ,
      cancelButtonText: ''+this.mensajesTraducirTS.guarda_12, // advice 4
    }).then((result) => {
      if (result.value) {
        this.fieldArrayTask2.push(this.newAttributeTas2k);
        this.newAttributeTas2k= {};
        this.dataTaskprimary = {
          idSeccion : idseccion,
          fechaDocumentador: this.fechaCertificar,
        };
          this.idiomasService.SaveTareaPrimaria(this.dataTaskprimary).subscribe((data : any) => {
            this.PrimaryTaskTmpFirts=data.tarea;
            this.IdPrimarytaskTmpFirtsSave=this.PrimaryTaskTmpFirts._id;
         });
      }
    })
  }

  infoCT:any;
  estadoCT:boolean = false;
  idCt_tmp:any;
  CT_files:any[]=[];
  CT_files2:backInter.prodNorma35;
  deleteFieldValuePrimaryTask(index) {
    this.fieldArrayTask2.splice(index, 1);
  }
  // FUNCIÓN PARA OBTENER LAS DIFERENTES TAREAS QUE SE DEBEN CUMPLIR
  private getAllPrimaryTask(seccionId,tittle){
    this.data = {
      seccionId: seccionId,
      fechaDocumentador: this.fechaCertificar
    }

    this.idiomasService.getTareasPrimaria(this.data).subscribe((data : any)=>{
      // SECCIÓN PARA CARGAR ARCHIVOS AL DOCUMENTADOR DE CENTRO DE TRABAJO HIJOS
      this.infoCT = this.idiomasService.getinfo();

      if(this.infoCT.level==6){
        this.estadoCT=true;
        this.idiomasService.getTareasPrimaria_CT(this.data,this.infoCT.empresaPadre).subscribe((data_hijos : any)=>{
          this.CT_files=data_hijos.tareas;
          this.CT_files2=data_hijos.tareas;
        });

      }
        var fechaTask;
        var fechfechaTaskFin;
        this.primaryTask = data.tareas;
        this.validadorMatArchivo=[this.primaryTask.length];
        this.validadorMatSelect=[this.primaryTask.length];
        for(var p=0; p < this.primaryTask.length; p++){ // Ciclo para ver si aún no tiene acortado la ruta manda a llamar al servicio
          for(var arPos=0; arPos < this.primaryTask[p].archivos.length; arPos++){
            if(this.primaryTask[p].archivos[arPos].acortador){
            }else{
              this.data = {
                seccionId : seccionId,
                tareaId: this.primaryTask[p]._id,
                archivoId: this.primaryTask[p].archivos[arPos]._id,
                fechaDocumentador: this.fechaCertificar,
                acortador: this.pathTmp+this.primaryTask[p].archivos[arPos].rutaArchivo
              };
              this.idiomasService.updatePrimaryFile(this.data).subscribe( (data : any) => {
                console.log("Respuesta de acortador");
                console.log(data);
              });
            }
          }


          if(this.primaryTask[p].estatus){}else{
            this.primaryTask[p].estatus="Elegir";
          }
          var dataAux:any[]=[];
          this.files.push(dataAux);
          var currentUtcTime = new Date(); // This is in UTC
          var currentDateTimeCentralTimeZone = new Date(this.primaryTask[p].fechaFin.toLocaleString('es-es', { timeZone: 'America/Mexico_City' }));
          var date = new Date(currentDateTimeCentralTimeZone),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
          var dateTmp= date.getFullYear()+'/'+mnth+'/'+day;

          fechaTask=this.primaryTask[p].fechaCreacion.toString();
          fechfechaTaskFin=this.primaryTask[p].fechaFin.toString();
          this.primaryTask[p].fechaCreacion=fechaTask.substr(2,8);
          this.primaryTask[p].fechaFin=dateTmp;
          this.primaryTask[p]._id;

        if(this.primaryTask[p].archivos.length >0){
          this.validadorMatArchivo[p]=false;
        }
        else{
          this.validadorMatArchivo[p]=true;
        }
        if(this.primaryTask[p].observaciones){
          if(this.primaryTask[p].observaciones.length > 0){
            this.validadorMatSelect[p]=false;
          }
          else {
            this.validadorMatSelect[p]=true;
          }
        }else{
          this.validadorMatSelect[p]=true;
        }
        this.dataFilePrimary = {
          // Archivos
            seccionId: seccionId,
            tareaId: this.primaryTask[p]._id,
            fechaDocumentador: this.fechaCertificar,
          };
        }
    });
  }


  private onPrimaryTask(event,idseccion,idTarea,tipo){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.data = {
      idSeccion : idseccion,
      idTarea: idTarea,
      fechaDocumentador: this.fechaCertificar,
      descripcion: this.typeEvent,
      //estatus: "",
    };

      this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
        if(tipo==2){
          this.fieldArrayTask2.splice(0, 1);
          let dataIdarch = {
            seccionId: idseccion,
            fechaDocumentador: this.fechaCertificar
          }
          this.actualizarTareas(dataIdarch);
        }
        console.log(data);
      });
  }
  private onTaskSupport(event,idseccion,idTarea,tipo){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.data = {
      idSeccion : idseccion,
      idTarea: idTarea,
      fechaDocumentador: this.fechaCertificar,
      apoyo: this.typeEvent,
      //estatus: "No cumple",
    };

    this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
      if(tipo==2){
        this.fieldArrayTask2.splice(0, 1);
        let dataIdarch = {
          seccionId: idseccion,
          fechaDocumentador: this.fechaCertificar
        }
        this.actualizarTareas(dataIdarch);
      }
      console.log(data);
    });
  }






  private onTaskNumeral(event,idseccion,idTarea){
    let Numeral:number;
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }

    this.data = {
      idSeccion : idseccion,
      idTarea: idTarea,
      fechaDocumentador: this.fechaCertificar,
      numero: this.typeEvent,
    };
    this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }

  private onStatusTask( idseccion,idTarea){
    var tmpstring:any;
    this.Tmpstatus=""+this.favoriteSeason;
    this.data = {
      idSeccion : idseccion,
      idTarea: idTarea,
      fechaDocumentador: this.fechaCertificar,
      estatus: this.Tmpstatus,
    };
    this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }

  datosOpc = ["Cumple","No cumple","No aplica"];
  private doStatus(datoOpc,idSeccionTmp,idTarea,index,k,observaciones,archivos,tamanio){

    let id;
    let cumple = false;
    /*if($("#"+idTarea+"-5").val().length==0 )
     {
       Swal.fire({
         icon: 'warning',
         title: ''+this.mensajesTraducirTS.guarda_5,
         confirmButtonColor: '#e40601'
       });
     }
     else {
      Swal.fire({
        title: ''+this.mensajesTraducirTS.guarda_6,
        allowOutsideClick:false,
        didOpen: () => {
          Swal.showLoading()
        }
      });

        if (datoOpc == "No cumple") {
          this.colorStatus(index, "#FADACE");
          cumple = true;
        }
        if (datoOpc == "No aplica") {
          this.colorStatus(index, "#FFFF00");
          cumple = true;
        }
        if (datoOpc == "Cumple") {
          if (this.primaryTask[k].archivos.length > 0) {
            this.colorStatus(index, "#E2FCC5");
            cumple = true;
          }else{
            Swal.fire({
              icon: 'warning',
              title: ''+this.mensajesTraducirTS.guarda_1,
              confirmButtonColor: '#e40601'
            });
          }
        }
        if(cumple){
          this.data = {
            idSeccion : idSeccionTmp,
            idTarea: idTarea,
            fechaDocumentador: this.fechaCertificar,
            estatus: datoOpc,
          };
          this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
            this.enviaOrdenWizard35();
            let dataIdarch = {
              seccionId: idSeccionTmp,
              fechaDocumentador: this.fechaCertificar
            }
            this.actualizarTareas(dataIdarch);
          });
        }
    }*/

      if (datoOpc == "No cumple") {
        this.colorStatus(index, "#FADACE");
        cumple = true;
      }
      if (datoOpc == "No aplica") {
        this.colorStatus(index, "#FFFF00");
        cumple = true;
      }
      if (datoOpc == "Cumple") {
        if (this.primaryTask[k].archivos.length > 0) {
          this.colorStatus(index, "#E2FCC5");
          cumple = true;
        }else{
          Swal.fire({
            icon: 'warning',
            title: ''+this.mensajesTraducirTS.guarda_1,
            confirmButtonColor: '#e40601'
          });
        }
      }
      if(cumple){
        this.data = {
          idSeccion : idSeccionTmp,
          idTarea: idTarea,
          fechaDocumentador: this.fechaCertificar,
          estatus: datoOpc,
        };
        this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
          this.enviaOrdenWizard35();
          let dataIdarch = {
            seccionId: idSeccionTmp,
            fechaDocumentador: this.fechaCertificar
          }
          this.actualizarTareas(dataIdarch);
        });
      }

  }

  private colorStatus(index,nameColor){
    for (var i = 1; i < 8; i++) {
      if(index==i){
        document.getElementById(index+i).style.backgroundColor = nameColor;

      }

    }
  }


  private onPrimaryObs(event,idseccion,idTarea,iterador?){
    let statusObs:any;
    statusObs=event.target.value.trim();
    this.typeEvent = event.target.value;
      this.validadorMatSelect[iterador] = false;
      this.data = {
        idSeccion : idseccion,
        idTarea: idTarea,
        fechaDocumentador: this.fechaCertificar,
        observaciones: this.typeEvent,
      };
      this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
        let dataIdarch = {
          seccionId: idseccion,
          fechaDocumentador: this.fechaCertificar
        }
        this.actualizarTareas(dataIdarch);

    });
    /*if(statusObs.length==0){

      Swal.fire({
        icon: 'warning',
        title: ''+this.mensajesTraducirTS.guarda_11, // advice 5
        confirmButtonColor: '#e40601'
      });
      let dataIdarch = {
        seccionId: idseccion,
        fechaDocumentador: this.fechaCertificar
      }
      this.validadorMatSelect[iterador] = true;
      this.actualizarTareas(dataIdarch);
    }else{



    } */
  }

  private onPrimaryCheck(tipo,idseccion,idTarea,iterador?){

    if(this.PasswordInabe){
      if(tipo==1){
        this.data = {
          idSeccion : idseccion,
          idTarea: idTarea,
          fechaDocumentador: this.fechaCertificar,
          verificado: "1",
        };
      }else{
        this.data = {
          idSeccion : idseccion,
          idTarea: idTarea,
          fechaDocumentador: this.fechaCertificar,
          verificado: "2",
        };
      }
      this.validadorMatSelect[iterador] = false;
      this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
        Swal.fire({
          icon: 'success',
          title: 'Tarea validada', //advice 7
          html: '<h1></h1>',
          timer: 1500
        });
        let dataIdarch = {
          seccionId: idseccion,
          fechaDocumentador: this.fechaCertificar
        }
        this.actualizarTareas(dataIdarch);
      });

    }else{
      Swal.fire({
        icon: 'error',
        title: 'Usted no tiene permiso para realizar esta acción', //advice 7
        html: '<h1></h1>',
        timer: 1500
      });

    }

  }
  actualizarObservaciones(dataIdarch){
    this.idiomasService.getTareasPrimaria(dataIdarch).subscribe((data : any)=>{
      this.primaryTask=data.tareas;
      this.validadorMatArchivo=[];
      this.validadorMatSelect=[];
      for(var p=0; p < this.primaryTask.length; p++){
        if(this.primaryTask[p].estatus){}else{
          this.primaryTask[p].estatus="No cumple";
        }
        let fechaTask=this.primaryTask[p].fechaCreacion.toString();
        let fechfechaTaskFin=this.primaryTask[p].fechaFin.toString();
        var currentUtcTime = new Date(); // This is in UTC
        var currentDateTimeCentralTimeZone = new Date(this.primaryTask[p].fechaFin.toLocaleString('es-es', { timeZone: 'America/Mexico_City' }));
        var date = new Date(currentDateTimeCentralTimeZone),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        var dateTmp= date.getFullYear()+'/'+mnth+'/'+day;

        this.primaryTask[p].fechaCreacion=fechaTask.substr(2,8);
        this.primaryTask[p].fechaFin=dateTmp.substr(2,8);
        if(this.primaryTask[p].archivos.length >0){
          this.validadorMatArchivo[p]=false;
        }
        else{
          this.validadorMatArchivo[p]=true;
        }
        if(this.primaryTask[p].observaciones.length > 0){
          this.validadorMatSelect.push(false);
        }
        else {
          this.validadorMatSelect.push(true);
        }
      }
    });

  }

  fileChangePrimary(element) {
    this.uploadedFilesPrimary = element.target.files;
  }


  addFieldValueP(index) {
    this.lado=index;
    this.fieldArrayTask3.push(this.newAttributeTask3)
    this.newAttributeTask3= {};
  }
  deleteFieldValueP(index) {
    this.fieldArrayTask3.splice(index, 1);
  }

 deletePrimaryTask(idseccion,idtarea){
    let dataTask = {
      fechaDocumentador: this.fechaCertificar,
      idSeccion: idseccion,
      idTarea:idtarea
    }
    this.idiomasService.borrarTareaPrimaria(dataTask).subscribe( (data : any) => {
      let dataArch = {
        seccionId: idseccion,
        fechaDocumentador: this.fechaCertificar
      }
      this.idiomasService.getTareasPrimaria(dataArch).subscribe((data : any)=>{
        this.primaryTask=data.tareas;
      });

    });

  }

  uploadFile(event,idseccion,idtarea,files,k) {
    for(let m=0; m < this.arrayFIlesTmp.length; m++){
      this.arrayFIlesTmp.pop();
    }
    this.arrayFIlesTmp=[];
    this.index_tmpFile=k;
    this.tmpIndex_aux=idtarea;
    this.uploadedFiles4 = event;
    let formData = new FormData();
    for (var i = 0; i < this.uploadedFiles4.length; i++) {
      formData.append('file',this.uploadedFiles4[i]);
    }
    formData.append("fechaDocumentador",this.fechaCertificar);
    formData.append("seccionId",idseccion);
    formData.append("tareaId",idtarea);
    this.idiomasService.saveFilesTaks(formData).subscribe( (data : any) => {
      console.log("Guardar archivo man");
      console.log(data);
      if(data.message == "File upload"){
        Swal.fire({
          icon: 'success',
          title: ''+this.mensajesTraducirTS.guarda_7, //advice 7
          html: '<h1></h1>',
          timer: 1500
        });
        let dataIdarch = {
          seccionId: idseccion,
          fechaDocumentador: this.fechaCertificar
        }
        this.idiomasService.getTareasPrimaria(dataIdarch).subscribe((data : any)=>{
          // AQUÍ DEBES PONER EL CAMPO BOOLEAN PORQUE YA SE HA CARGADO UN ARCHIVO
          this.primaryTask=data.tareas;
          this.validadorMatArchivo=[];
          this.validadorMatSelect=[];
          for(var p=0; p < this.primaryTask.length; p++){
            if(this.primaryTask[p].estatus){}else{
              this.primaryTask[p].estatus="No cumple";
            }
            let fechaTask=this.primaryTask[p].fechaCreacion.toString();
            let fechfechaTaskFin=this.primaryTask[p].fechaFin.toString();
            var currentUtcTime = new Date(); // This is in UTC
            var currentDateTimeCentralTimeZone = new Date(this.primaryTask[p].fechaFin.toLocaleString('es-es', { timeZone: 'America/Mexico_City' }));
            var date = new Date(currentDateTimeCentralTimeZone),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
            var dateTmp= date.getFullYear()+'/'+mnth+'/'+day;
            this.primaryTask[p].fechaCreacion=fechaTask.substr(2,8);
            this.primaryTask[p].fechaFin=dateTmp;
            if(this.primaryTask[p].archivos.length >0){
              this.validadorMatArchivo.push(false);
            }
            else{
              this.validadorMatArchivo.push(true);
            }

            if(this.primaryTask[p].observaciones==null){
              this.validadorMatSelect[p]=true;
            }else{
              if(this.primaryTask[p].observaciones.length > 0){
                this.validadorMatSelect[p]=false;
              }
              else {
                this.validadorMatSelect[p]=true;
              }
            }
          }
        });
      }else{
        Swal.fire({
          icon: 'error',
          title: ''+this.mensajesTraducirTS.guarda_3, // Advice 3
          html: '<h1></h1>',
          timer: 1500
        });
      }
    });
  }

  deleteAttachment(arrayFileIndex,index,seccionid,tareaid,archivoid) {
    this.files[arrayFileIndex].splice(index, 1);
    this.arrayFIlesTmp[arrayFileIndex].splice(index, 1);
    this.data = {
      seccionId : seccionid,
      tareaId: tareaid,
      archivoId: archivoid,
      fechaDocumentador: this.fechaCertificar,
    };
    this.idiomasService.deletePrimaryFile(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }

  deleteAttachmentTask(index) {
    this.files.splice(index, 1);
  }

  activarAlertaEvi(k:number){ // MANDA NOTIFICACIONES DE QUE NO EXISTE ARCHIVO
    if(this.validadorMatArchivo[k]){
    Swal.fire({
      icon: 'warning',
      title: ''+this.mensajesTraducirTS.guarda_1, // advice 1
      confirmButtonColor: '#e40601'
    });}
  }

  activarAlertaob(k:number){ // MANDA NOTIFICACIÓN DE QUE NO TIENE OBSERVACIONES
    if(this.validadorMatSelect[k]){
    Swal.fire({
      icon: 'warning',
      title: ''+this.mensajesTraducirTS.guarda_5, // advice 5
      confirmButtonColor: '#e40601'
    });}
  }

   deletePrimaryFile(index,seccionid,tareaid,archivoid,archivos,k,statusTarea){
     this.File_tmpaux=archivos;
     this.data = {
      seccionId : seccionid,
      tareaId: tareaid,
      archivoId: archivoid,
      fechaDocumentador: this.fechaCertificar
    };
    if(this.File_tmpaux.length == 1 && statusTarea == 'Cumple'){
      Swal.fire({
        icon: 'warning', // advice 8
        title: ''+this.mensajesTraducirTS.guarda_8,
        html: '<h1></h1>',
        timer: 1500
      });
    }
    else{
      this.idiomasService.deletePrimaryFile(this.data).subscribe( (data : any) => {
        if(data.message == 'Successfully deleted'){
          this.File_tmpaux.splice(index, 1);
          if(this.File_tmpaux.length == 0){
            this.validadorMatArchivo[k] = true;
          }
          Swal.fire({
            title: ''+this.mensajesTraducirTS.guarda_6,
            timer: 4500,
            allowOutsideClick:false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
          let dataIdarch = {
            seccionId: seccionid,
            fechaDocumentador: this.fechaCertificar
          }
          this.actualizarTareas(dataIdarch);
        }
      });
    }
  }
  info:any;
  obtieneCertificarActual(){

    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      console.log("Data certifiar");
      console.log(data);
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaCertificar=this.productoCertificar.fechaNorma35;
              this.typeContent=this.productoCertificar.tipo;
              console.log("TYypeContent "+this.typeContent);
              console.log(this.typeContent);
                 // CENTROS DE TRABAJO HIJOS
                 this.info=this.colaboradoresService.getinfo();
               // FIN CENTRO DE TRABAJO HIJO
              throw BreakException;
            }
          }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  enviaOrdenWizard35(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }


  regexAlfanumerico = new RegExp("^[a-zA-Z0-9 ÁÉÍÓÚÜáéíóúüñÑ().,:_-]*$");
  validacionAlfanumerica(dato:any){
    return this.regexAlfanumerico.test(dato);
  }
  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;
  }

  actualizarTareas(dataIdarch){
    this.idiomasService.getTareasPrimaria(dataIdarch).subscribe((data : any)=>{
      this.primaryTask=data.tareas;
      this.validadorMatArchivo=[];
      this.validadorMatSelect=[];
      for(var p=0; p < this.primaryTask.length; p++){
        if(this.primaryTask[p].estatus){}else{
          this.primaryTask[p].estatus="No cumple";
        }
        let fechaTask=this.primaryTask[p].fechaCreacion.toString();
        let fechfechaTaskFin=this.primaryTask[p].fechaFin.toString();

        var currentUtcTime = new Date(); // This is in UTC
        var currentDateTimeCentralTimeZone = new Date(this.primaryTask[p].fechaFin.toLocaleString('es-es', { timeZone: 'America/Mexico_City' }));
        var date = new Date(currentDateTimeCentralTimeZone),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        var dateTmp= date.getFullYear()+'/'+mnth+'/'+day;

        this.primaryTask[p].fechaCreacion=fechaTask.substr(2,8);
        this.primaryTask[p].fechaFin=dateTmp;
        this.primaryTask[p]._id;
        if(this.primaryTask[p].archivos.length >0){
          this.validadorMatArchivo[p]=false;
        }
        else{
          this.validadorMatArchivo[p]=true;
        }
        if(this.primaryTask[p].observaciones==null){
          this.validadorMatSelect[p]=true;
        }else{
          if(this.primaryTask[p].observaciones.length > 0){
            this.validadorMatSelect[p]=false;
          }
          else {
            this.validadorMatSelect[p]=true;
          }
        }
      }
      setTimeout(()=>{Swal.close();},1200);
    });
  }

  Secciones_D: any[]=["56","51a","51b"];
  dataStep5 = [
    {
       //  Documentar política  5.1
      position: 52,
      tittle: "5.2 Identificar y analizar los factores de riesgo psicosocial",
      cap: "Numeral de la NOM-035-STPS-2018 5.1",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE1",
      linktitle:"WIZARD.DOCUMENTO_SOPORTE.CONTENT1.DOC4",
      ruta:'/NOM35/wizard/politicas-ejemplo',
      flag: 1,
      img: "1",
      Urltitle:"Reglamento federal de seguridad y salud en el trabajo: ",
      Subtitle:" revisar artículo 7 inciso 1 y artículo 43.",
      link:"https://www.gob.mx/indesol/documentos/reglamento-federal-de-seguridad-y-salud-en-el-trabajo",
    },{
      // Este pertenece  a Encuesta NOM035 16-50 Colaborasores
      // Num 2
      // Identificar y analizar factores de riesgo psicosocial 5.2
      position: 53,
      tittle: "5.3 Identificar y analizar los factores de riesgo psicosocial",
      cap: "Númerales de la NOM-035-STPS-2018 5.2, 7.1a, 7.2",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE2",
      linktitle:"WIZARD.DOCUMENTO_SOPORTE.CONTENT1.DOC2",
      ruta:'/NOM35/wizard/guia-II',
      flag: 1,
      img: "2",
      Urltitle:"Reglamento federal de seguridad y salud en el trabajo:",
      Subtitle:"revisar artículo 7 inciso 1 y artículo 43.",
      link:"https://www.gob.mx/indesol/documentos/reglamento-federal-de-seguridad-y-salud-en-el-trabajo",
    },{
      // Este pertenece
      // Num 3
      // Identificar y analizar factores de riesgo psicosocial 5.2
      position: 54,
      tittle : "5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial",
      cap: "Numerales de la NOM-035-STPS-2018 5.3, 7.1b, 7.2 y 7.3",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE3",
      linktitle:"WIZARD.DOCUMENTO_SOPORTE.CONTENT1.DOC3",
      ruta:'/NOM35/wizard/guia-III',
      flag: 1,
      img: "3",
      Urltitle:"Reglamento federal de seguridad y salud en el trabajo:",
      Subtitle:"revisar artículo 7 inciso 1 y artículo 43.",
      link:"https://www.gob.mx/indesol/documentos/reglamento-federal-de-seguridad-y-salud-en-el-trabajo",
    },{
      // Este pertenece
      // Num 4
      position: 55,
      tittle: "5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos",
      cap: "Numerales de la NOM-035-STPS-2018 5.4, 8.1, 8.2",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE4",
      linktitle:"WIZARD.DOCUMENTO_SOPORTE.CONTENT1.DOC3",
      ruta:'/NOM35/wizard/guia-III',
      flag: 1,
      img: "4",
      Urltitle:"Reglamento federal de seguridad y salud en el trabajo:",
      Subtitle:"revisar artículo 17 inciso 2 y artículo 43.",
      link:"https://www.gob.mx/indesol/documentos/reglamento-federal-de-seguridad-y-salud-en-el-trabajo",
    },{
      // Este pertenece
      // Num 5
      position: 56,
      tittle: "5.6 Practicar exámenes médicos y evaluaciones psicológicas",
      cap: "Numeral de la NOM-035-STPS-2018 8.1",
      subtittle: "Mecanismos seguros y confidenciales para la recepción de quejas por prácticas opuestas al entorno organizacional favorable y para denunciar actos de violencia laboral ",
      linktitle:"",
      flag: 2,
      img: "5",
      Urltitle:"",
      Subtitle:"",
      link:"",
    },{
      // NUM 6
      position: "51a",
      tittle: "5.1 a) La prevención de los factores de riesgo psicosocial",
      cap: "Numerales de la NOM035 8.2, 8.5",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE5",
      linktitle:"",
      flag: 2,
      img: "6",
      Urltitle:"",
      Subtitle:"",
      link:"",
    },{
      // NUM7
      position: "51b",
      tittle: "5.1 b) La prevención de la violencia laboral",
      cap: "Numerales de la NOM-035-STPS-2018 8.3, 8.4, 8.5",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE6",
      linktitle:"",
      flag: 2,
      img: "7",
      Urltitle:"",
      Subtitle:"",
      link:"",
    },{
      // NUM 8
      position: "51c",
      tittle: "5.1 c) La promoción de un entorno organizacional favorable",
      cap: "Numeral de la NOM-035-STPS-2018 5.5",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE7",
      linktitle:"WIZARD.DOCUMENTO_SOPORTE.CONTENT1.DOC1",
      ruta:'/NOM35/wizard/guia-I',
      flag: 1,
      img: "8",
      Urltitle:"NOM-021-STPS-1994.",
      Subtitle:"",
      link:"http://www.dof.gob.mx/nota_detalle.php?codigo=4697709&fecha=24/05/1994",
    },{
      // NUM9
      position: "57a",
      tittle: "5.7 a) La política de prevención de riesgos psicosociales",
      cap: "5.6",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE8",
      linktitle:"",
      flag: 1,
      img: "9",
      Urltitle:"NOM-021-STPS-1994.",
      Subtitle:"",
      link:"http://www.dof.gob.mx/nota_detalle.php?codigo=4697709&fecha=24/05/1994",
    },{
      // NUM10
      position: "57b",
      tittle: "5.7 b) Las medidas adoptadas para combatir las prácticas opuestas",
      cap: "5.7, 5.8",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE9",
      linktitle:"",
      flag: 1,
      img: "10",
      Urltitle:"Reglamento federal de seguridad y salud en el trabajo:",
      Subtitle:"revisar artículo 17 inciso 2 y artículo 43.",
      link:"https://www.gob.mx/indesol/documentos/reglamento-federal-de-seguridad-y-salud-en-el-trabajo",
    },{
      // NUM 11
      position: "57c",
      tittle: "5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...",
      cap: "5.8 ",
      subtittle: "WIZARD.LANDING.PRODUCTO.DOCUMENTADOR_TITLE.TITLE10",
      linktitle:"",
      flag: 1,
      img: "11",
      Urltitle:"Reglamento federal de seguridad y salud en el trabajo: ",
      Subtitle:"revisar artículo 43.",
      link:"https://www.gob.mx/indesol/documentos/reglamento-federal-de-seguridad-y-salud-en-el-trabajo",
    }
  ]
  openDialog(opcionData?:any,videotitle?:any,idSeccion?:any,idTarea?:any,informacion?:any, typeEvent?:any, status?:boolean): void {
    let dataModal: any;
    const dialogRef = this.dialog.open(DialogTableVideo, {
      width: '3500px', height: '600px',
      data: { opcion: opcionData, title: videotitle, seccionId:idSeccion,tareaId:idTarea, infoapoyo:informacion, tipo:typeEvent,status:status }

    });
    dialogRef.afterClosed().subscribe(result => {
      let dataIdarch = {
        seccionId: idSeccion,
        fechaDocumentador: this.fechaCertificar
      }
      if(idSeccion){
        this.actualizarTareas(dataIdarch);
      }
    });
  }

}

@Component({
  selector: 'DialogTableVideo',
  templateUrl: 'tables-steps-dialog.html',
  styleUrls: ['./tables-steps.component.scss']
})

export class DialogTableVideo {

  private _unsubscribeAll: Subject<any>;
  constructor(
    private colaboradoresService: Colaboradores35Service,
    private idiomasService: IdiomasServiceN35,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    public dialogRef: MatDialogRef<DialogTableVideo>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this.obtieneCertificarActual();
      this._unsubscribeAll = new Subject();
      lang_wizard.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      console.log(data);
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  @Input() inputArray: Array<any>[];
  public longText = longText;
  public minRows = 3;
  public maxRows = 4;
  public onlyGrow = true;
  public useImportant = true;
  productoCertificar: backInter.prodNorma35;
  fechaCertificar:any;
  typeEvent:any;
  dataInfo : any;
  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaCertificar=this.productoCertificar.fechaNorma35;
              throw BreakException;
            }
          }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  private onTaskSupport(event,idseccion,idTarea){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.dataInfo = {
      idSeccion : idseccion,
      idTarea: idTarea,
      fechaDocumentador: this.fechaCertificar,
      apoyo: this.typeEvent,
    };

    this.idiomasService.SaveTareaPrimaria(this.dataInfo).subscribe( (dataService : any) => {
      console.log(dataService);
    });
  }

  mensaje:string = "Y";
}
